import React, { useContext, useEffect, useState } from "react";
import { Button, Input, InputGroup, InputGroupText } from "reactstrap";
import LinkContext from "../../Links/Context/Index";
import EmptyState from "../../../Shared/Components/EmptyState";
import { getLinksApi } from "../../../Shared/Api/GetLinks";

export default function LinksList({ model_id, model_type }) {
  const [links, setLinks] = useState([]);
  const [filters, setFilters] = useState({});
  const fetchLinks = async () => {
    let response = await getLinksApi({
      ...filters,
    });
    if (response.result === "success") {
      setLinks(response.data?.items);
    }
  };
  useEffect(() => {
    setFilters({
      ...filters,
      model_id,
      model_type,
    });
  }, [model_id, model_type]);

  useEffect(() => {
    if (filters?.model_id && filters?.model_type) {
      fetchLinks();
    }
  }, [filters]);

  return (
    <>
      {Array.isArray(links) && links?.length === 0 && <EmptyState />}
      {Array.isArray(links) &&
        links.map(function (link, i) {
          return (
            <InputGroup className="mb-2" key={i}>
              <Input
                disabled
                type="url"
                value={link?.url}
                placeholder="www.enlace1.com"
                style={{
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                }}
              />
              <InputGroupText
                style={{
                  padding: 0,
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                }}
              >
                <Button
                  color="primary"
                  onClick={() => window.open(link?.url, "_blank")}
                  style={{
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  IR
                </Button>
              </InputGroupText>
            </InputGroup>
          );
        })}
    </>
  );
}
